import { createFileRoute } from "@tanstack/react-router";
import ServiceAreasIndexPage from "@/pages/ServiceAreasIndexPage";
import { canonicalUrl } from "@/lib/site";

export const Route = createFileRoute("/service-areas/")({
  head: () => ({
    meta: [
      {
        title: "Service Areas | Scotty's Land Specialist in Highland, UT",
      },
      {
        name: "description",
        content:
          "The truck runs about 9 miles out of Highland for clearing, dumpsters, seasonal cleanup, and snow. Weed control also reaches larger lots out to about 30 miles.",
      },
      {
        property: "og:title",
        content: "Service Areas | Scotty's Land Specialist in Highland, UT",
      },
      {
        property: "og:description",
        content:
          "The truck runs about 9 miles out of Highland for clearing, dumpsters, seasonal cleanup, and snow. Weed control also reaches larger lots out to about 30 miles.",
      },
      { property: "og:type", content: "website" },
      { property: "og:url", content: canonicalUrl("/service-areas") },
      { name: "twitter:card", content: "summary_large_image" },
      {
        name: "twitter:title",
        content: "Service Areas | Scotty's Land Specialist in Highland, UT",
      },
      {
        name: "twitter:description",
        content:
          "The truck runs about 9 miles out of Highland for clearing, dumpsters, seasonal cleanup, and snow. Weed control also reaches larger lots out to about 30 miles.",
      },
    ],
    links: [{ rel: "canonical", href: canonicalUrl("/service-areas") }],
  }),
  component: ServiceAreasIndexPage,
});
